import React from 'react';
import { connect } from 'react-redux';
import fetch from '../hooks/fetch';
import CohortPanelContainer, { mapDispatchToProps, mapStateToProps } from '../components/CohortPanelContainer';
import CohortErrorMessages from '../components/CohortErrorMessages';
import SelectCohortSource from '../components/SelectCohortSource';
import CohortNoDatasetAccess from './CohortNoDatasetAccess';
import CohortInfoGrid from '../components/CohortInfoGrid';

const CohortPanelFull = ({
  activeQueryUUID,
  allowCohortVisualisations,
  canRead,
  category,
  code,
  description,
  exists,
  isDirty,
  isNew,
  name,
  onChange,
  queryAccess,
  readErrors,
  readStatus,
  validationErrors,
  saveErrors,
  selectSource,
  updateProperties,
  url,
  expandedCharts,
}) => {
  fetch.useFetchCohort({ category, code, isNew }, readStatus);
  return (
    <CohortPanelContainer
      canRead={canRead}
      description={description}
      exists={exists}
      isDirty={isDirty}
      isNew={isNew}
      name={name}
      onChange={onChange}
      readErrors={readErrors}
      readStatus={readStatus}
      validationErrors={validationErrors}
      saveErrors={saveErrors}
      url={url}
    >
      <div className="aridhia-cohort-panel-full">
        <CohortErrorMessages
          code={code}
          category={category}
          entities={['server', 'cohort', 'query', 'clause', 'filter']}
          readErrors={readErrors}
          saveErrors={saveErrors}
          updateProperties={updateProperties}
          validationErrors={validationErrors}
        />
        {selectSource && (<SelectCohortSource code={code} category={category} />)}
        {!queryAccess && (<CohortNoDatasetAccess code={code} category={category} />)}
        {!selectSource && (
          <CohortInfoGrid
            code={code}
            category={category}
            isNew={isNew}
            queryAccess={queryAccess}
            queryUUID={activeQueryUUID}
            allowCohortVisualisations={allowCohortVisualisations}
            expandedCharts={expandedCharts}
          />
        )}
      </div>
    </CohortPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(CohortPanelFull);
